var MotionGlobalConfig = {
  skipAnimations: false
};
export { MotionGlobalConfig };